/**
 *  Created by long.wang on 2019/4/11
 */
export default {
  sensors: {
    server_url: 'https://sensorsdata.ppdai.com/sa/?project=default',
    show_log: true
  },
  LYCF_LOGIN_URL: '//fat-ac.lyfortune.com/h5/authLogin?thirdAppId=40f7bfd4466b4ed9830a2b02f0dff3e5&thirdCallUrl=http://passport.ppdapi.com/v2/authorizedLoginService/queryPhoneByOpenId?appid=1000003195&',
}
